import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import moment from 'moment';
import ReactNotification from 'react-notifications-component';
import 'mobx-react-lite/batchingForReactDom';
import 'react-notifications-component/dist/theme.css';
import { createMuiTheme, ThemeProvider, StylesProvider } from '@material-ui/core/styles';
import { lang } from './lib/loc';
import App from './App';

import './index.scss';

moment.locale(lang());

const theme = createMuiTheme({
    palette: {
        primary: {
            main: '#cc0514',
        },
    },
    breakpoints: {
        values: {
            xxs: 0,
            xs: 375,
            sm: 576,
            md: 768,
            lg: 992,
            xl: 1200,
        },
    },
    typography: {
        fontFamily: 'Lato',
        body1: {
            fontSize: '16px',
            lineHeight: '24px',
            letterSpacing: 0.25,
        },
        h6: {
            fontWeight: 500,
            fontSize: '20px',
            lineHeight: '24px',
        },
    },
    // overrides
    overrides: {
        MuiTypography: {
            body2: {
                color: '#777',
            },
        },
        MuiInput: {
            // root: {
            //     padding: '10px 0 ',
            //     '&::placeholder': {
            //         color: 'red',
            //     },
            // },
            // input: {
            //     padding: '10px 0 ',
            //     '&::placeholder': {
            //         color: '#999999',
            //     },
            // },
        },
        MuiAutocomplete: {
            // input: {
            //     padding: '10px 0 ',
            //     '&::placeholder': {
            //         color: '#999999',
            //     },
            // },
        },
        MuiInputBase: {
            input: {
                padding: '10px 0 ',
                '&::placeholder': {
                    color: '#999999',
                },
            },
        },
        MuiButton: {
            root: {
                fontSize: 12,
                fontWeight: 700,
                letterSpacing: '0.05em',
                borderRadius: 0,
                padding: '1.1em 2em 1em',
            },
            contained: {
                boxShadow: 'none',
            },
            outlined: {
                padding: '1.05em 2.4em 0.9em',
            },
            outlinedSizeSmall: {
                fontSize: 12,
                padding: '0.6em 1.4em 0.5em',
            },
            outlinedPrimary: {
                borderColor: '#cc0514',
                transition: 'all .3s ease',
                '&:hover': {
                    color: '#fff',
                    backgroundColor: '#cc0514',
                },
            },
        },
    },
});

ReactDOM.render(
    <StylesProvider>
        <ThemeProvider theme={theme}>
            <BrowserRouter basename={'/' + process.env.REACT_APP_ROUTE_BASE}>
                <ReactNotification />
                <App />
            </BrowserRouter>
        </ThemeProvider>
    </StylesProvider>,
    document.getElementById('personal-area_root-container'),
);
